export const SKULL_ASCII = `
    ██████████████████████████████████
    █░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░█
    █░░▄▀▀▀▀▀▀▀▀▀▀▄░░░▄▀▀▀▀▀▀▀▀▀▀▄░░█
    █░░█░░░░░░░░░░█░░░█░░░░░░░░░░█░░█
    █░░░▀▀▀▀▀▀▀▀▀▀░░░░░▀▀▀▀▀▀▀▀▀▀░░░█
    █░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░█
    █░░░░░░▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄░░░░░░░░█
    █░░░░░░░░░░░▄▄▄▄▄▄▄░░░░░░░░░░░░░░█
    █░░░░░░░░░░░░░░▄░░░░░░░░░░░░░░░░░█
    ██████████████████████████████████
`

export const SKULL_SIMPLE = `
      ___
     /   \\
    | O O |
    |  ▼  |
     \\___/
`

export const DANGER_BANNER = `
╔═══════════════════════════════════════════════════════════════╗
║   ⚠️  DANGER ZONE - CRITICAL SECURITY EXPLOIT ACTIVATED  ⚠️   ║
╚═══════════════════════════════════════════════════════════════╝
`

export const HACKER_BANNER = `
 █▀▀ ▀▄▀ █▀█ █░░ █▀█ █ ▀█▀   █▀█ █▀█ █▀▀
 ██▄ █░█ █▀▀ █▄▄ █▄█ █ ░█░   █▀▀ █▄█ █▄▄
`

export const ACCESS_GRANTED = `
╔═══════════════════════════════════════╗
║     █████╗  ██████╗ ██████╗           ║
║    ██╔══██╗██╔════╝██╔════╝           ║
║    ███████║██║     ██║                ║
║    ██╔══██║██║     ██║                ║
║    ██║  ██║╚██████╗╚██████╗           ║
║    ╚═╝  ╚═╝ ╚═════╝ ╚═════╝           ║
║        GRANTED                        ║
╚═══════════════════════════════════════╝
`

export const BREACH_DETECTED = `
╔═══════════════════════════════════════════╗
║  ██████╗ ██████╗ ███████╗ █████╗  ██████╗██╗  ██╗ ║
║  ██╔══██╗██╔══██╗██╔════╝██╔══██╗██╔════╝██║  ██║ ║
║  ██████╔╝██████╔╝█████╗  ███████║██║     ███████║ ║
║  ██╔══██╗██╔══██╗██╔══╝  ██╔══██║██║     ██╔══██║ ║
║  ██████╔╝██║  ██║███████╗██║  ██║╚██████╗██║  ██║ ║
║  ╚═════╝ ╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝ ╚═════╝╚═╝  ╚═╝ ║
║              DETECTED!                            ║
╚═══════════════════════════════════════════════════╝
`

export const SYSTEM_BREACH = `
░██████╗██╗░░░██╗░██████╗████████╗███████╗███╗░░░███╗
██╔════╝╚██╗░██╔╝██╔════╝╚══██╔══╝██╔════╝████╗░████║
╚█████╗░░╚████╔╝░╚█████╗░░░░██║░░░█████╗░░██╔████╔██║
░╚═══██╗░░╚██╔╝░░░╚═══██╗░░░██║░░░██╔══╝░░██║╚██╔╝██║
██████╔╝░░░██║░░░██████╔╝░░░██║░░░███████╗██║░╚═╝░██║
╚═════╝░░░░╚═╝░░░╚═════╝░░░░╚═╝░░░╚══════╝╚═╝░░░░░╚═╝
██████╗░██████╗░███████╗░█████╗░░█████╗░██╗░░██╗
██╔══██╗██╔══██╗██╔════╝██╔══██╗██╔══██╗██║░░██║
██████╦╝██████╔╝█████╗░░███████║██║░░╚═╝███████║
██╔══██╗██╔══██╗██╔══╝░░██╔══██║██║░░██╗██╔══██║
██████╦╝██║░░██║███████╗██║░░██║╚█████╔╝██║░░██║
╚═════╝░╚═╝░░╚═╝╚══════╝╚═╝░░╚═╝░╚════╝░╚═╝░░╚═╝
`

export const IP_EXPOSED = `
██╗██████╗░  ███████╗██╗░░██╗██████╗░░█████╗░░██████╗███████╗██████╗░██╗
██║██╔══██╗  ██╔════╝╚██╗██╔╝██╔══██╗██╔══██╗██╔════╝██╔════╝██╔══██╗██║
██║██████╔╝  █████╗░░░╚███╔╝░██████╔╝██║░░██║╚█████╗░█████╗░░██║░░██║██║
██║██╔═══╝░  ██╔══╝░░░██╔██╗░██╔═══╝░██║░░██║░╚═══██╗██╔══╝░░██║░░██║╚═╝
██║██║░░░░░  ███████╗██╔╝╚██╗██║░░░░░╚█████╔╝██████╔╝███████╗██████╔╝██╗
╚═╝╚═╝░░░░░  ╚══════╝╚═╝░░╚═╝╚═╝░░░░░░╚════╝░╚═════╝░╚══════╝╚═════╝░╚═╝
`

export const LOADING_FRAMES = [
  '⠋',
  '⠙',
  '⠹',
  '⠸',
  '⠼',
  '⠴',
  '⠦',
  '⠧',
  '⠇',
  '⠏',
]

export const TERMINAL_HEADER = `
┌──────────────────────────────────────────────────────────────────┐
│  URBAN VPN EXPLOIT TERMINAL v1.0.0 - UNAUTHORIZED ACCESS ONLY   │
├──────────────────────────────────────────────────────────────────┤
`

export const TERMINAL_FOOTER = `
└──────────────────────────────────────────────────────────────────┘
`
